module.exports = __webpack_public_path__ + "static/media/pc.31fe7537.JPG";